<template>
    <layout-card
        :error="error"
        :loading="loading"
        :isCustomizable="settings.isCustomizable"
        @hide-card="$emit('hide-card', type)"
        @edit-card="toggleSettingsForm"
        @refresh-card="fetchCard(type, {}, true)"
        class="card-opportunity"
    >
        <template slot="title">
            {{ name }}
        </template>
        <template slot="actions">
            <CompassIconButton
                v-if="settings.canCreate"
                icon="plus"
                onclick="Opportunity.addOpportunity()"
            />
        </template>
        <template slot="content">
            <template-kpi-card :data="{ stats: cardData, labels: labels }" />

            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import TemplateKpiCard from './TemplateKpiCard.vue';
import CardMixin from './CardMixin.js';

export default {
    mixins: [CardMixin],
    data() {
        return {
            labels: {
                month: {
                    label: this.$l10n.__('À échéance ce mois'),
                    labelCount: this.$l10n.__('Opportunités'),
                },
                week: {
                    label: this.$l10n.__('À échéance cette semaine'),
                    labelCount: this.$l10n.__('Opportunités'),
                },
                open: {
                    label: this.$l10n.__('Ouverte'),
                    labelCount: this.$l10n.__('Opportunités'),
                },
                late: {
                    label: this.$l10n.__('En retard'),
                    labelCount: this.$l10n.__('Opportunités'),
                },
            },
            settingsFormName: 'opportunity-setting-form',
        };
    },
    components: {
        LayoutCard,
        TemplateKpiCard,
    },
};
</script>
